import {createSelector} from 'reselect';
import pageSelector from './pageSelector';

export default createSelector(
  pageSelector,
  page => page.get('dashboardCharacters')
);



// WEBPACK FOOTER //
// ./app/features/dashboard/selectors/pages/list/dashboardCharactersArraySelector.js